import React from 'react';
import {IncidentListDTO} from 'hemwb-api';
import {TO_LOCALE_DATE_STRING_OPTIONS} from '../../../../../core/TableWithSortAndPagination';
import {fullName} from '../../../../../../store/user/utils';
import styles from './IncidentTextOverview.module.scss';

type IncidentTextOverviewProps = {
  incident: IncidentListDTO;
};

const IncidentTextOverview: React.FC<IncidentTextOverviewProps> = ({incident}) => {
  const incidentTime = incident.incidentTime?.toLocaleDateString('en-US', TO_LOCALE_DATE_STRING_OPTIONS) || '-';
  const createdBy = fullName(incident.createdBy) || '-';

  return (
    <div className={styles.detailsGrid}>
      <section className={styles.block}>
        <h4 className={styles.label}>Incident Summary:</h4>
        <p className={styles.value}>{incident.issueSummary || '-'}</p>
      </section>

      <section className={styles.block}>
        <h4 className={styles.label}>Incident Details:</h4>
        <p className={styles.value}>{incident.stackTrace || '-'}</p>
      </section>

      <section className={styles.block}>
        <h4 className={styles.label}>Incident Time:</h4>
        <p className={styles.value}>{incidentTime}</p>
      </section>

      <section className={styles.block}>
        <h4 className={styles.label}>User Notes:</h4>
        <p className={styles.value}>{incident.userNotes || '-'}</p>
      </section>

      <section className={styles.block}>
        <h4 className={styles.label}>Created By:</h4>
        <p className={styles.value}>{createdBy}</p>
      </section>
    </div>
  );
};

export default IncidentTextOverview;
